import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-8 text-center">
      <h1 className="text-4xl font-bold text-primary">
        Location Scout
      </h1>
      <p className="text-xl text-secondary">
        Find your next business opportunity with AI-powered location analysis
      </p>
      <button
        onClick={() => navigate('/search')}
        className="px-6 py-3 bg-accent text-accent-foreground rounded hover:bg-accent/90 transition-colors"
      >
        <Search className="inline-block mr-2" />
        Start Scouting
      </button>
    </div>
  );
};

export default HomePage;